/* @flow */
/*global $, refreshProductInfo, globalItemInfoPage*/
/*eslint camelcase: [2, {properties: "never"}]*/
$(function () {
  "use strict";
  var productInfoForm = $("#product_info_form");
  var applySelectionsFromLocalStorage = applySelectionsFromLocalStorage;
  var processGoToSwatches = processGoToSwatches;
  var initAddToBasketTracking = initAddToBasketTracking;

  processGoToSwatches();
  applySelectionsFromLocalStorage();

  //if there's no choice to be made we need to call refreshProductInfo in order for the ecommerce tracking to work on add to basket
  if (INFO_PAGE.refreshSettings.size_id && INFO_PAGE.refreshSettings.colour_id) {
    initAddToBasketTracking();
  }


  productInfoForm.on("click", "a.product_option", function (e) {
    var selectionHighlightsActive = $(".inactive-buy").text() === "Please Make Selections";
    e.preventDefault();
    // e.stopPropagation();
    refreshProductInfo(this.id, false, selectionHighlightsActive);
  });

  productInfoForm.on("click", "a.clear_product_info", function (e) {
    var selectionHighlightsActive = $(".inactive-buy").text() === "Please Make Selections";
    e.preventDefault();
    e.stopPropagation();
    refreshProductInfo("0", true, selectionHighlightsActive);
  });

  $("[data-action=\"checkQty\"]").change(function () {
    if ($(this).val() > $(this).attr("data-qty-limit")) {
      $(this).val($(this).attr("data-qty-limit"));
    }
  });

  function processGoToSwatches() {
    if (Modernizr.sessionstorage) {
      if (sessionStorage.getItem("goToSwatches") !== null) {
        sessionStorage.removeItem("goToSwatches");
        $('#material-swatches').get(0).scrollIntoView(true);
      }
    }
  }

  function applySelectionsFromLocalStorage() {
    var categorySettings;
    var sizeId, secondarySizeId;
    if (!Modernizr.localstorage) {
      return false;
    }

    categorySettings = JSON.parse(localStorage.getItem("categorySettings"));

    if (!categorySettings || !categorySettings.hasOwnProperty(globalItemInfoPage.categoryUrlTitle)) {
      return false;
    }

    if (categorySettings[ globalItemInfoPage.categoryUrlTitle ].hasOwnProperty("sizeId")) {
      sizeId = parseInt(categorySettings[ globalItemInfoPage.categoryUrlTitle ].sizeId);
    }

    if (categorySettings[ globalItemInfoPage.categoryUrlTitle ].hasOwnProperty("secondarySizeId")) {
      secondarySizeId = parseInt(categorySettings[ globalItemInfoPage.categoryUrlTitle ].secondarySizeId);
    }

    //if there's not size selected (via cookie at php), and lc size is available, apply it
    if (sizeId && !$("#sizes a.active").length) {
      if ($("#sizes #size-" + sizeId).length) {
        var selectionHighlightsActive = $(".inactive-buy").text() === "Please Make Selections";
        refreshProductInfo("size-" + sizeId, false, selectionHighlightsActive);
      }
    }

    //in theory they shouldn't arrive at a product page with a conflicting size and secondary size because the product
    //wouldn't have shown in the list, so we shouldn't have to worry about race conditions or applying incompatible
    //combinations
    //if there's not size selected (via cookie at php), and lc size is available, apply it
    if (secondarySizeId && !$("#secondary_sizes a.active").length) {
      if ($("#secondary_sizes #secondary-size-" + secondarySizeId).length) {
        var selectionHighlightsActive = $(".inactive-buy").text() === "Please Make Selections";
        refreshProductInfo("secondary-size-" + secondarySizeId, false, selectionHighlightsActive);
      }
    }
  }

  function initAddToBasketTracking() {

    var data = '';

    data += 'category_id';
    data += "=";
    data += escape(INFO_PAGE.refreshSettings.category_id);
    data += "&";

    data += 'category';
    data += "=";
    data += escape(INFO_PAGE.refreshSettings.category);
    data += "&";

    data += 'style_id';
    data += "=";
    data += escape(INFO_PAGE.refreshSettings.style_id);
    data += "&";

    data += 'style';
    data += "=";
    data += escape(INFO_PAGE.refreshSettings.style_title);
    data += "&";

    data += 'brand_id';
    data += "=";
    data += escape(INFO_PAGE.refreshSettings.brand_id);
    data += "&";

    data += 'brand';
    data += "=";
    data += escape(INFO_PAGE.refreshSettings.brand);
    data += "&";

    data += 'size_id';
    data += "=";
    data += escape(INFO_PAGE.refreshSettings.size_id);
    data += "&";

    data += 'size';
    data += "=";
    data += escape(INFO_PAGE.refreshSettings.size_title);
    data += "&";

    data += 'secondary_size_id';
    data += "=";
    data += escape(INFO_PAGE.refreshSettings.secondary_size_id);
    data += "&";

    data += 'secondary_size';
    data += "=";
    data += escape(INFO_PAGE.refreshSettings.secondary_size);
    data += "&";

    data += 'colour_id';
    data += "=";
    data += escape(INFO_PAGE.refreshSettings.colour_id);
    data += "&";

    data += 'colour';
    data += "=";
    data += escape(INFO_PAGE.refreshSettings.colour);
    data += "&";

    data += 'fabric_id';
    data += "=";
    data += escape(INFO_PAGE.refreshSettings.fabric_id);
    data += "&";

    data += 'fabric';
    data += "=";
    data += escape(INFO_PAGE.refreshSettings.fabric);
    data += "&";

    data += 'occasion_id';
    data += "=";
    data += escape(INFO_PAGE.refreshSettings.occasion_id);
    data += "&";

    data += 'occasion';
    data += "=";
    data += escape(INFO_PAGE.refreshSettings.occasion);
    data += "&";

    data += 'sale';
    data += "=";
    data += escape(INFO_PAGE.refreshSettings.sale);
    data += "&";

    data += 'product_id';
    data += "=";
    data += escape(INFO_PAGE.refreshSettings.product_id);
    data += "&";

    data += 'so_id';
    data += "=";
    data += escape(INFO_PAGE.refreshSettings.so_id);
    data += "&";

    var rand = Math.random(9999);
    var pars = data + 'rand=' + rand;

    $.get('/lib/ajax_product_info_json.php', pars, function (newData) {

      // $("#product_info_form #buy").unbind('click');
      $("#product_info_form #buy").on('click', function (e) {
        e.stopPropagation();
        var qtyInput = $('#qty_heading + input');

        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "add_to_cart",
            currency: "GBP",
            value: newData.plain_price,
            ecommerce: {
                items: [ {
                  item_id: INFO_PAGE.refreshSettings.product_id,
                  item_name: INFO_PAGE.product_title,
                  item_category: INFO_PAGE.refreshSettings.category,
                  item_variant: newData.plain_size + ' ' + newData.plain_secondary_size + ' ' + newData.colour,
                  item_brand: INFO_PAGE.product_brand,
                  currency: "GBP",
                  price: newData.plain_price,
                  quantity: qtyInput.val(),
                  index: 0,
                  dimension1: newData.plain_size,
                  dimension2: newData.plain_secondary_size,
                  dimension3: newData.colour,
                } ]
            }
          });
        } catch (error) {
          // console.log(error);
        }

        $('#photo-carousel').carousel({ interval: false });
        $(".carousel").swiperight(function () {
          $(".carousel").carousel('prev');
        });
        $(".carousel").swipeleft(function () {
          $(".carousel").carousel('next');
        });

      });
    });
  }
});
